import { downloadTemplate } from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { TableColumn } from "@/config/types";
import { getFileFromBlobResponse } from "@/config/utils";
import { useContext, useState } from "react";
import { toast } from "react-toastify";

export function useTemplatesAndInstructionsDesktop() {
  const { lang } = useContext(PspContext);

  const [templateActionOpenId, setTemplateActionOpenId] = useState<
    string | null
  >(null);
  const [openFilePreview, setOpenFilePreview] = useState<File | null>(null);
  const [templatePreviewOpenId, setTemplatePreviewOpenId] = useState<
    string | null
  >(null);

  const columns: TableColumn[] = [
    {
      key: "title",
      label: translate("title", lang),
      className: "w-2/3",
    },
    {
      key: "templateType",
      label: translate("templateType", lang),
      className: "min-w-44 w-1/3",
    },
    {
      key: "action",
      label: translate("action", lang),
      className: "w-16",
    },
  ];

  function onOpenPreview() {
    if (templateActionOpenId) {
      downloadTemplate({
        path: { template_id: templateActionOpenId },
        responseType: "blob",
      }).then((response) => {
        if (response.error) {
          toast(translate("somethingWentWrong", lang));
        } else {
          setOpenFilePreview(getFileFromBlobResponse(response));
          setTemplatePreviewOpenId(templateActionOpenId);
          setTemplateActionOpenId(null);
        }
      });
    } else {
      toast(translate("somethingWentWrong", lang));
    }
  }

  function onClosePreview() {
    setTemplatePreviewOpenId(null);
    setOpenFilePreview(null);
  }

  return {
    lang,
    columns,
    templateActionOpenId,
    setTemplateActionOpenId,
    openFilePreview,
    onOpenPreview,
    templatePreviewOpenId,
    onClosePreview,
  };
}
